export function OpenFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 6a3 3 0 013-3h3.172a3 3 0 012.12.879L15 7.586 17.586 5H15a1 1 0 110-2h4.5A1.5 1.5 0 0121 4.5V9a1 1 0 11-2 0V6.414L16.414 9l3.707 3.707A3 3 0 0121 14.828V18a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm11.793 1.793l-4.5 4.5a1 1 0 101.414 1.414l4.5-4.5-1.414-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
